import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=1c028698"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=1c028698&prod&lang=scss"
import style1 from "./TabelaCadastros.vue?vue&type=style&index=1&id=1c028698&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports